import shared from "./shared/shared.js";
//import checkout from './checkout/checkout.js'
import * as causelist from "./causelist/causelist";
import frontendProductPage from "./frontend-productpage/frontend-productpage";
import * as frontendProductGallery from "./frontend-productgallery/frontend-productgallery";
//import * as profile from "./profile";
import * as topbarBanner from "./topbar-banner";
import * as header from "./header";

export default {
    //checkout: checkout,
    causelist: causelist,
    shared: shared,
    frontendProductPage,
    frontendProductGallery,
    async frontendCompanyFormula() {
        const frontendCompanyFormula = await import(
            "./frontend-company-formula/frontend-company-formula.js"
        );
        return frontendCompanyFormula.default.formula;
    },
    //profile,
    topbarBanner,
    header,
};
